import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=d13d8b8a&scoped=true"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSelector.vue?vue&type=style&index=0&id=d13d8b8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d8b8a",
  null
  
)

export default component.exports